import React, { useState, useRef, useEffect} from "react";

import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';

import styles from '@/styles'
import bg1 from './images/bg1.png';
import arrow from './images/arrow.png';
import cardBg from './images/card.png';
import styled from "styled-components";
import Slider from 'react-slick';

import award1 from './images/award1.png';
import award2 from './images/award2.png';
import award3 from './images/award3.png';
import award4 from './images/award4.png';
import award5 from './images/award5.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Goods from "./goods"
import bridge from '@/config/JSbridge'
import { connect } from 'react-redux'
import { jumpTo, getObjectFormSerach } from "../../utils";
import Delivery from "./components/delivery";
import { getActivityUserInfo, saveAddrInfo, getAddrInfo } from '@/api/user-new'
import { getCouponActivity } from '@/api/base'

import { Toast } from "antd-mobile";
import OpenApp from '../../components/OpenApp';
import Detention from './components/Detention'
import FirstMoadl from './components/firstMoadl'

// import ShareModal from '../active_138/components/share';
// import ShareModal from './../active_138/components/share';
import ShareModal from './components/share';
import Modal from './components/modal'
export const isStorm = bwmodel.app === 'storm';

const active_id = 139
const Component = ({userId,token}) => {
const [isAutoplay, setIsAutoPlay] = useState(true);

  const [activeGoods,setActiveGoods] = useState({})
  const [isBuy, setIsBuy] = useState(false)
  const [awardList, setAwardList] = useState([]);

  const { source } = getObjectFormSerach(window.location.search);
  
  let sliderRef = useRef(null);
  const [deliveryVisible, setDeliveryVisible] = useState(false);
  const deliveryRef = useRef('');
  const [showAddr,setShowAddr] = useState(false);
  const detentionRef = useRef('');
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const newVal =  year.toString() + month + day;
  const firstMoadl = useRef();
  const shareRef = useRef()
  const modelRef = useRef('');
  // let sliderRef = useRef(null);
  const activityShare = () => {
    
      // 埋点
      // handleUploadTrace('7th-anniversary_desc-share', 'click')
      //
      if (!isStorm) {
          return linkToDownload()
      }
      if (shareRef.current) {
        shareRef.current.show()
      }

  }

useEffect(()=> {
  initData();

},[])

function initData() {
  
  getData();
  // 初始化轮播

  sliderRef.slickGoTo(0);
  setActiveGoods(Goods.goods[0])

  getCouponActivity(active_id)
  .then((res)=> {
    if(res.isWatch === 0) {
      firstMoadl.current.show()
      setIsAutoPlay(false);
    } 

    if(res.awardedList) {
      setIsBuy(true);
      const awardList = [];
      res.awardedList
        .sort((a,b) => a.skuId <= b.skuId? -1 : 1)
        .forEach(it => {
          const skuId = it.skuId;
          Goods.goods.find(goods => {
            if(goods.skuId === skuId) {
              awardList.push(goods)
              return true
            }
            return false
          })
        })
      setAwardList(awardList)

      const params = {
        activityId: active_id, 
      }
      
      if(awardList.find(it => it.skuId === 3)) {
   
        getAddrInfo(params)
        .then(res => {
          if(res.recipientPhone) {
            setShowAddr(false)
          } else {
            // 
            setShowAddr(true)
          }
          // console.log(res);
        })
      }
    }
  })
 // 是否显示地址
}


let getData = () => {

  getActivityUserInfo(active_id)
    .then(res => {
      // console.log(res.endTime);
      // setTimeOver(res.activityState === 2);

      // }
    })
}

  const width = window.screen.width/5;

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: width + "px",
    slidesToShow: 1,
    autoplaySpeed: 3000,
    speed: 500,
    beforeChange: (index,next) => {
      const goods = Goods.goods[next];
      setActiveGoods(goods)
    }
  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }
  const handleShareClick = () => {
    // if(!activeVisible) {
    //   return
    // }
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }


  function showAddrInfo(params) {
    setDeliveryVisible(true)
  }
  const handleGoShop = (item) => {
   
    if (source === 'mini') {
      /* eslint-disable no-undef */
      wx.miniProgram.navigateTo({url: '/pages/kefu/index'})
      return
    }

    if (!isStorm) {
      return linkToDownload()
    }
    
    if (!token) {
      return  handleLogin()
    }

    sliderRef.slickPause();
    
    const slider = sliderRef;
    
    bridge.callHandler('nativeEvent', {
      // event: (isiOS &&  bwmodel.compareVersion('6.12.0')) ?"iOSIAPPay":  'halfScreenPay',
      event: 'halfScreenPay',
      params: {
        price: item.price,
        activityTitle: item.name,
        skuId: `${item.skuId}`,
        orderType: `${item.spuId}:1:139`
      },
    }, (params) => {
      try {
        slider && slider.slickPlay();
        slider && slider.slickGoTo(0);
  
   
        const info = JSON.parse(params);
        if (info && info.params.result) {
          initData();
          localStorage.setItem(`active140_${userId}_${newVal}_isBuy`, JSON.stringify(true)); // 是否已经购买
        }
      } catch (error) {
        //
        console.log(error);
        slider && slider.slickPlay();
       
      }
    })
  }

   // 挽留了
   function handleDetain() {
    localStorage.setItem(`active140_${userId}_${newVal}_isBuy`, JSON.stringify(true)); // 是否已经购买
  }
  const handleSubmitAddr = (addr) => {
    const params = {
      activityId: 139,
      ...addr,
      // giftList: [goodsName1 ,goodsName2]
    }

    saveAddrInfo(params)
    .then(res => {
      Toast.info('地址填写成功')
      setTimeout(()=> {
        // onClose();
        setDeliveryVisible(false)
        setShowAddr(false);
      }, 1500)
   
    })
    .catch(err => {
      // onClose();
      console.log(err);
    })
  }
  const handleLeftClick = () => {
    const isBuy = localStorage.getItem(`active140_${userId}_${newVal}_isBuy`); // 是否已经购买
    
    if(isBuy === "true") {
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    } else {
  
      detentionRef.current.show()
      localStorage.setItem(`active140_${userId}_${newVal}_isBuy`, true)
    }
  }
  
    return (
      <div>
      {isStorm && 
        <Header
          title="市值风云专属活动"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
          leftClick={()=> {
            handleLeftClick()
          }}
          bg_color={styles.bg_color2}
        />}
      <Container>
        <div className="bg1" >
          {/* <div className="time">活动时间：2024.12.10-2025.1.10</div> */}
         
          <div class="time">会员涨价前最后一次活动！</div>
          <div className="flex">
            <img src={require('./images/aw1.png')} alt="" />
            <img src={require('./images/aw2.png')} alt="" />
            <img src={require('./images/aw3.png')} alt="" />
          </div>
        </div>
        <Slider 
          ref={slider => {
            sliderRef = slider;
          }}
          {...settings} 
          autoplay={isAutoplay}
          initialSlide={0}
        >
          { Goods.goods.map((it,index) => 
            (<div key={it.skuId} className={ activeGoods.skuId === it.skuId ? 'card active': 'card' }>
              <Card  onClick={() => {
                sliderRef.slickGoTo(index);

                setActiveGoods(it)
              }}>
             
                <div className="icon">{it.icon}</div>
                <div className="name">{it.name}年卡 </div>
                <div className="content">
                  { it.content.map(i =>  <div>{i}</div> ) }
                </div>
                <div className="priceCard">
                    <div className="priceLeft">
                        <div className="originPrice">日常价 ¥{it.originPrice}</div>
                        <div className="price">狂欢价 <span>¥{it.price}</span></div>
                    </div>
                    <div className="priceRight">
                        <div>立减<br/>{it.originPrice - it.price}元</div>
                    </div>
                </div>
                <div className="btn"
                  onClick={(event)=> {
                    event.stopPropagation();
                    handleGoShop(it);
                  }}
                >
                  {it.icon} 立即抢购
                </div>
              </Card>
            </div>)
            )
          }
        </Slider>
    <div className="title">
      <span>会员权益对比</span> 
      <img src={require('./images/rect.png')} alt="" />
    </div>

    <div className="rules_btn" onClick={
        ()=>jumpTo('/active_139/rules')
      }><span>活</span><span>动</span><span>规</span><span>则</span>
      </div>

      <div
        className="rules_btn"
        style={{top: '180px'}}
        onClick={
          ()=>jumpTo('https://www.wogoo.com/essay/#/?articleId=d2d70d6d67634be893fb2d2500bf16fa&articleType=1')
        }
      ><span>会</span><span>员</span><span>介</span><span>绍</span></div>
     
      <div className="table_box">
        <div className="table">
          <table border="none" style={{borderCollapse: "collapse", border: "none"}} cellpadding="0" cellspacing="0">
            <tr>
              <th className="name"><span>会员权益</span></th>
              { Goods.tableGoods.map(i =>  <th>{i}</th>) }
            </tr>
            {
              Goods.rightsMap.map(it =>  
                <tr>
                  <td className="name"><span>{it.name}</span></td>
                  { it.rights.map(i =>  <td>{ i === 1?'✓':i=== 2?'/':'部分可见'}</td>)}
                </tr>
              )
            }
          </table>
        </div>
        <div className="table table2">
          <table border="none" style={{borderCollapse: "collapse", border: "none"}} cellpadding="0" cellspacing="0">
            <tr>
              <th className="name"><span>会员权益</span></th>
            </tr>
            {
              Goods.rightsMap.map(it =>  (
                  <tr>
                    <td className="name"><span>{it.name}</span></td>
                  </tr>
                )
              )
            }
          </table>
        </div>
      </div>
      {/* <div className='fixed_box'
          style={{bottom: '180px'}}
          onClick={()=>{
            modelRef.current.setShow(true);
          }}
        >
          <img className="fixed_img"
          src={require('./../activity_145/img/春节发货悬浮球@2x.png')} alt="市值风云" />
        </div> */}
    </Container>
    {
      (isBuy && ((activeGoods && (activeGoods.skuId !== 3)) || awardList.filter(it => it.skuId === 3 ).length)) ? 
      <Footer className="bottom-container footer-freeclass-block" id="footer" >
        <div className="bottom-box">
          <div className="title">
            <div>目前已得： </div>
            {
              showAddr && <div className="button" onClick={()=>showAddrInfo()}>填写收货信息</div>
            }
             
          </div>
          <div className="imgs_box_container">
            <div className="imgs_box">
              {
                awardList.map(it => {
                return <React.Fragment>
                  {
                    it.skuId === 3 ? 
                    <div className="arward arward1">
                      风云VIP时长 <br/> 372+<span>93天</span>
                    </div>:
                    <div className="arward arward5">
                      {it.name}时长 <br/> 372+<span>93天</span>
                    </div>
                  }
                  
                </React.Fragment>
                }) 
              }

            {
              awardList.filter(it => it.skuId === 3 ).map(it => {
                return <div className="arward arward2">
                  股市好运 <br/> 18籽串
                </div>
              })
            }

            {
              awardList.filter(it => it.skuId === 3 ).map(it => {
                return <div className="arward arward3">
                    ETF <br/> 投资地图
                </div>
              })
            }

            {
              awardList.filter(it => it.skuId === 3 ).map(it => {
                return <div className="arward arward4">
                  股市专属 <br/> 涨停符
                </div>
              })
            }
          </div>
          </div>
          <div className="tips">
            购买会员赠送的奖励（会员天数和涨停大礼包）均在活动结束后统一发放
            <br/>
            {
               awardList.filter(it => it.skuId === 3 ).length >0 && awardList.filter(it => it.skuId !== 3 ).length >0
              && 
              <span> 注：风云VIP赠送的会员天数已含{awardList.filter((it,index) => it.skuId !== 3 && awardList.indexOf(it) === index ).map(it => (it.name+ ' '))}赠送天数，会统一根据风云VIP 赠送时长进行发放</span>
              
            }

            </div>
          </div>
        
          <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={139} />
      </Footer>
      : 
      <Footer className="bottom-container footer-freeclass-block" id="footer" >
        <div className="bottom-box">
          <div className="title">
            <div>购买 <span>{activeGoods.name}年卡会员</span> 可得：</div>
            <div className="button" onClick={()=>handleGoShop(activeGoods)}>购买会员>></div>
          </div> 
          <div className="imgs_box_container">
          <React.Fragment>
            {
            activeGoods.skuId === 3 ? 
              <div className="imgs_box">
                <div className="arward arward1">
                  风云VIP时长 <br/> 372+<span>93天</span>
                </div>
            
              <div className="arward arward2">
                  股市好运 <br/> 18籽串
                </div>
                <div className="arward arward3">
                  ETF <br/> 投资地图
                </div>
                <div className="arward arward4">
                  股市专属 <br/> 涨停符
                </div>
                </div>
              :
              <div className="imgs_box">
                <div className="arward arward5">
                  {activeGoods.name}时长 <br/> 372+<span>93天</span>
                </div>
              </div>
            }
          </React.Fragment>
          </div>
          </div>
      </Footer>
    
    }

{ 
//   (isBuy ||  (activeGoods && activeGoods.skuId) ) &&
//     <Footer className="bottom-container footer-freeclass-block" id="footer" >
//       <div className="bottom-box">
//       {
//         awardList.map(it => it.skuId).includes(activeGoods.skuId) ?
//         <div className="title">
//           <div>目前已得：</div>
//           {
//             showAddr && <div className="button" onClick={()=>showAddrInfo()}>填写收货信息</div>
//           }
//         </div>
//           :
//         <div className="title">
//           <div>购买 <span>{activeGoods.name}年卡会员</span> 可得：</div>
//           <div className="button" onClick={()=>handleGoShop(activeGoods)}>购买会员>></div>
//         </div> 
//       }

//         <div className="imgs_box_container">
//           {
//             activeGoods.skuId ?
//             <div className="imgs_box">
//               {
//                 activeGoods.skuId === 3 ? 
//                 <div className="arward arward1">
//                   风云VIP时长 <br/> 372+<span>93天</span>
//                 </div>:
//                 <div className="arward arward5">
//                   {activeGoods.name}时长 <br/> 372+<span>93天</span>
//                 </div>
//               }
//               {
//                 activeGoods.skuId === 3 && <React.Fragment>
//                   <div className="arward arward2">
//                     股市好运 <br/> 18籽串
//                   </div>
//                   <div className="arward arward3">
//                       市值风云 <br/> 投资笔记
//                   </div>
//                   <div className="arward arward4">
//                     股市专属 <br/> 涨停符
//                   </div>
//                 </React.Fragment>
//                 }
//               </div>
       
//         : <div className="imgs_box">
//           {
//             awardList.map(it => {
//              return <React.Fragment>
//               {
//                 it.skuId === 3 ? 
//                 <div className="arward arward1">
//                   风云VIP时长 <br/> 372+<span>93天</span>
//                 </div>:
//                 <div className="arward arward5">
//                   {it.name}时长 <br/> 372+<span>93天</span>
//                 </div>
//               }
              
//              </React.Fragment>
//             }) 
//           }

//           {
//             awardList.filter(it => it.skuId === 3 ).map(it => {
//               return <div className="arward arward2">
//                 股市好运 <br/> 18籽串
//               </div>
//             })
//           }
// {
//             awardList.filter(it => it.skuId === 3 ).map(it => {
//               return <div className="arward arward3">
//                    市值风云 <br/> 投资笔记
//               </div>
//             })
//           }

// {
//             awardList.filter(it => it.skuId === 3 ).map(it => {
//               return <div className="arward arward4">
//                股市专属 <br/> 涨停符
//               </div>
//             })
//           }
            
          
//           </div>
//         }


//         </div>
        

//         {
//           isLock ?
//             <div >
//               <div className="tips">
//               赠送的会员天数（红色）和周边奖品会在活动结束后统一发放
//             </div>
//               {
//               ( totalAwardList.filter(it => it.name === '风云VIP').length === 1 ) && totalAwardList.length > 1 &&
//               <div className="tips2">注：风云VIP赠送的会员天数已含{
//                 // 购买的其他类型会员名称，多个中间用、隔开
//                   totalAwardList.filter(it => it.name !== '风云VIP').map((it,index,a) => `${it.name}${(index !== a.length -1)?'、':''}`)
//                 }赠送天数，会统一根据风云VIP赠送时长进行发放
//               </div>
//               }
//           </div>
//           :
//         <div className="tips" >购买会员赠送的奖励（会员天数和涨停大礼包）均在活动结束后统一发放</div>
          
//         }
//       </div>
//       <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={139} />
//     </Footer>
    
  }
  <ShareModal ref={shareRef} onShareClick={handleShareClick}/>
   <Detention  detain={()=>handleDetain()} ref={detentionRef}/>
    {
      !isStorm && 
      <div>
        <OpenApp bottom='bottom'></OpenApp>
      </div>
      }
      <FirstMoadl accept={()=> {
        setIsAutoPlay(true);
        sliderRef.slickPlay();
        sliderRef.slickGoTo(0);
      
    }}  ref={firstMoadl} ></FirstMoadl>
    
        <Modal ref={modelRef}/>
  </div>
)}


const Container = styled.div`
  background-color:#9A2322;
  padding-bottom: 200px;
  position: relative;
  .fixed_box {
    position: fixed;
    bottom: 120px;
    width: 48px;
    right: 10px;
    z-index: 100;
    .fixed_img {
      width: 48px;
    }
  }
  .bg1{
    position: relative;
    background-image: url(${bg1});
    background-size: cover;
    background-repeat: no-repeat;
    height: 80vw;
    width: 100%;
    .time {
      text-align: center;
      position: absolute;
      text-align: center;
      top: 42vw;
      width: 100%;
      color: #FFFEFE;
    }
    .flex {
      position: absolute;
      bottom:0;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
      img {
        width: 29.8vw;
      }
    }
  }
  .rules_btn {
    position: absolute;
    right: 0;
    top: 80px;
    box-shadow: 0px 0px 8px 0px rgba(197,51,36,0.18);
    color: #FFFFFF;
    font-size: 10px;
    text-align: center;
    line-height: 12px;
    width: 16px;
    height: 55px;
    background: rgba(104,20,14,0.55);
    border-radius: 4px 0px 0px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    >span {
      display: block;
    }
  }

  .slick-prev, .slick-next {
    display: none !important;
  }
  .card {
    padding: 10px 0px;
    transition: transform 0.3s ease-in-out;
    &.active {
      transform: scale(1.08);
    }
  }
  .title {
    height: 43px;
    font-family: Alibaba PuHuiTi;
    font-weight: 800;
    font-size: 22px;
    color: #FFFEFE;
    line-height: 52px;
    text-align: center;
    position: relative;
    span {
      position: relative;
      z-index: 2;
    }
    padding-bottom: 0px;
    img {
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translateX(-50%);
      z-index: 1;
      width: 170px;
    }
  }
  .table_box {
    position: relative;
    margin-top: 20px;
    // color: #DB3800;
  }
   
  .table {
    border-radius:10px;
    border: 2px solid #FFD9CA;
    margin: 0 13px;
    overflow: scroll;
    color: #1A1A1A;
    table {
      border-collapse: collapse;
      border:none;
    }
    tr, td {
      height: 34px;
      border:none;
    }
      th{ 
          font-size: 16px;
          color: #DB3800;
          min-width: 80px;
          border:none;
      }
      td {
          text-align: center;
      }
      .name {
          text-align: left;
          min-width: 150px;
          span {
            padding-left: 15px;
          }
      }
    tr:nth-child(2n - 1) {
          background-color: #FDB6A4;
      }
      tr:nth-child(2n) {
          background-color: #FFFAF0;
      }
  }
  .table2{
      position: absolute;
      left: 0;
      top: 0;
      border-radius:10px 0 0 10px;
      border-right: none;
  }
`

const Card = styled.div`
    position: relative;
    background-image: url(${cardBg});
    background-size: cover;
    background-repeat: no-repeat;
    width: 56vw;
    height: 64.4vw;
    margin: auto;
   
    .icon {
        width: 100%;
        text-align: center;
        height: 23px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 12px;
        color: #FFFCF5;
        line-height: 6vw;
    }
    .name {
        text-align: center;
        font-family: Alibaba PuHuiTi;
        font-weight: 800;
        font-size: 23px;
        color: #292929;
        line-height: 10vw;
    }
    .content {
        text-align: center;
        font-size:16px;
        color: #977B56;
        line-height: 19px;
        height: 18.5vw;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

    }
    
    .priceCard {
        margin: 0 13px;
        height: 48px;
        background: #FFD9CA;
        border-radius: 5px 5px;
        over-flow: hidden;
        display: flex;
        justify-content: space-between;
        .priceLeft{
            height: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            font-size: 10px;
            color: #D97651;
            line-height: 13px;
            padding-left: 9px;
            .originPrice{
                margin-top: 9px;
                marign-bottom: 9px;
            }
            .price {
                font-size: 10px;
                font-weight: bold;
                color: #D13C28;
                margin-top: 3px;
                span {
                    font-size: 21px;
                }
            }
            
        }
        .priceRight {
            width: 65px;
            height: 49px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 13px;
            text-align: center;
            background-image: url(${arrow});
            background-size: contain;
            background-repeat: no-repeat;
            padding-top: 5px;
        }
       
    }
    .btn {
        position: absolute;
        background: linear-gradient(270deg, #E33515 0%, #FF8B24 99%);
        bottom: 2.7vw;
        color: #FFF;
        width: calc(100% - 26px);
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        margin:0px 13px;
    }
`



// const AwadBox = styled.div`
// width: 92vw;
// margin: auto;
// margin-top: 10vw;
// background: #FF6F6F;
// // background: red;
// border-radius: 15px;
//  color: #FFFFFF;
//   text-align: center;
//   box-sizing: border-box;
//   padding: 4.5vw;
//   .title {
//     font-size: 24px;
   
//     line-height: 40px;
//   }
//   .title_tips {
  
//   }
//   .title_images {
//     margin-top: 3vw;
//     display: flex;
//     justify-content: space-between;
//     img {
//       width: 18.4vw;
//     }
//   }
// `

const Footer = styled.div`

    position: fixed;
    width: 100%;
    left: 0;
    // bottom: -100%;
    z-index: 100;
    transition: bottom 0.5s;
    &.footer-freeclass-block {
        bottom: 0;
    }
   
    .bottom-box {
      padding: 15px;
      box-sizing: border-box;
      background: linear-gradient(145deg, #C23318, #FF7700);
      border-radius: 10px 10px 0 0;
      width: 100%;
      position: relative;
      .title {
        pading: 5px;
        box-sizing: border-box;
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        span {
          color:#FFEE5C;
        }
        .button {
          width: 98px;
          height: 28px;
          border: 1px solid #EAE0B2;

          background: linear-gradient(270deg, #EC5519 0%, #EC5519 100%);
          box-shadow: 0px 1px 3px 0px rgba(168,89,37,0.18);
          border-radius: 14px;
          text-align: center;
          line-height:28px;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
      .imgs_box_container{
        // width: 100%;
        overflow: scroll;
        //  width: 300px;
      }
      .imgs_box {
       
        display: flex;
        overflow-x: auto; /* 水平滚动条 */
        overflow: scroll;
        .arward {
          // float: left;
          min-width: 82px;
          width: 82px;
          height: 96px;
          background-image: url(${award1});
          background-repeat: no-repeat;
          background-size: cover;
          font-size: 12px;
          font-family: SourceHanSansSC;
          font-weight: 500;
          color: #333333;
          text-align: center;
          padding-top: 60px;
          box-sizing: border-box;
          margin-right: 8px;
        //  >span {
        //       color:#EB582D;
        //     }
        
            // transform-origin: center;
            // transform: scale(0.78);
            >span {
              color:#EB582D;
            }
          
        }
        .arward1 {
          background-image: url(${award1});
        }
        .arward2 {
          background-image: url(${award2});
        }
        .arward3 {
          background-image: url(${award3});
        }
        .arward4 {
          background-image: url(${award4});
        }
        .arward5 {
          background-image: url(${award5});
        }
      }
      .tips {
        margin-top: 8px;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 13px;
      }
      .bottom-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .unlock-btn {
        width: 88px;
        height: 74px;
        position: absolute;
        bottom: 18px;
        right: 22px;
        z-index: 10;
      }
      .reward-img {
        width: 197px;
        height: 75.5px;
        position: absolute;
        right: 15px;
        top: -57.5px;
      }
      
      .total-award {
        font-size: 38px;
        font-weight: bold;
        color: #FDE200;
        line-height: 38px;
      }
      .total-award-unit {
        font-size: 20px;
        font-weight: 800;
        color: #FDE200;
        line-height: 20px;
      }
    }
  
`



const mapStateToProps = (state) => ({
  token: state.user.accessToken || '',
  userId: state.user.userId || '',
});


export default React.memo(connect(mapStateToProps)(Component))
// export default Component


// WEBPACK FOOTER //
// ./src/views/activity_139/index.js